import { useState } from "react";

/** How the demo viewer plays, kept in this browser. */
export interface ViewerSettings {
  /** At the end of a round, carry on into the next one. */
  autoNext: boolean;
  /** Start each round when it goes live, freeze time skipped (a second before). */
  skipFreeze: boolean;
  /** The map follows the players still alive, zoomed on them. */
  autoZoom: boolean;
  /** Each player's name beside their weapon on the map. */
  names: boolean;
}

export const DEFAULT_VIEWER_SETTINGS: ViewerSettings = { autoNext: true, skipFreeze: false, autoZoom: false, names: true };
const KEY = "69ly.viewerSettings";

export function useViewerSettings(): [ViewerSettings, (change: Partial<ViewerSettings>) => void] {
  const [settings, setSettings] = useState<ViewerSettings>(() => {
    try {
      const saved = JSON.parse(localStorage.getItem(KEY) ?? "{}") as Partial<ViewerSettings>;
      return { ...DEFAULT_VIEWER_SETTINGS, ...Object.fromEntries(Object.entries(saved).filter(([k, v]) => k in DEFAULT_VIEWER_SETTINGS && typeof v === "boolean")) };
    } catch {
      return DEFAULT_VIEWER_SETTINGS;
    }
  });
  const change = (c: Partial<ViewerSettings>) =>
    setSettings((s) => {
      const next = { ...s, ...c };
      try {
        localStorage.setItem(KEY, JSON.stringify(next));
      } catch {
        // Private window: kept for this visit.
      }
      return next;
    });
  return [settings, change];
}
